/* leverege-molten no-export */
import { Config } from '@leverege/plugin';
import AbstractQueryTrigger from "./AbstractQueryTrigger.js";
import Timer from "./Timer.js";
const DEFAULT_CONFIG = {
  refreshOnError: false,
  refreshTime: 30000,
  errorRetryTimeout: 3000
};
export default class DefaultTriggerHandler extends AbstractQueryTrigger {
  constructor(opts, cxt) {
    super(opts, cxt);
    const config = Config.get('DefaultTriggerHandler', this.options.path);
    if (config) {
      this.config = {
        ...DEFAULT_CONFIG,
        ...config
      };
    } else {
      this.config = DEFAULT_CONFIG;
    }
    this.timerId = null;
    this.refreshTime = Config.get(this.options.client, 'refreshTime', this.config.refreshTime);
    this.refreshOnError = Config.get(this.options.client, 'refreshOnError', this.config.refreshOnError);
    this.errorAttempts = -1;
    this.errorRetryTimeout = this.config.errorRetryTimeout;
  }
  loadData = opts => {
    const {
      force
    } = opts || {};
    const {
      loadData
    } = this.options;
    const {
      extraQueryParams
    } = this.config;
    const eqp = typeof extraQueryParams === 'function' ? extraQueryParams(this.options, this.config) : extraQueryParams != null ? extraQueryParams : undefined;
    return loadData({
      ...eqp,
      force: force || this.config.refreshOnError
    }).then(res => {
      this.options.initialLoad?.resolve();
      return res;
    });
  };
  async preQuery() {
    this.refreshTimer?.clear();
  }
  async postQuery(err) {
    if (!err || this.refreshOnError) {
      this.setupPolling();
      this.errorAttempts = -1;
    } else if (err) {
      wait(this.errorRetryTimeout, ++this.errorAttempts).then(() => {
        this.loadData({
          force: true
        });
      });
    }
  }
  setupPolling() {
    this.refreshTimer?.clear();
    this.refreshTimer = Timer.create(this.loadData, this.refreshTime);
  }
  onVisibilityChange = evt => {
    if (evt.target.hidden) {
      this.refreshTimer?.pause();
    } else {
      this.refreshTimer?.resume();
    }
  };
  init() {
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    this.loadData();
  }
  cleanup() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    this.refreshTimer?.clear();
  }
}
function wait(timeout, attempt) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, 2 ** attempt * timeout);
  });
}